import React from "react";
import "../../styles/site.css";
import Header from "../Header/Header";
import Hero from "../Hero/Hero";
import Work from "../Work/Work";
import Services from "../Services/Services";
import Process from "../Process/Process";
import About from "../About/About";
import Contact from "../Contact/Contact";
import Footer from "../Footer/Footer";
import useSeo from "../../seo/useSeo";
import pages from "../../data/pages.json";

const Home = () => {
  useSeo(pages.home);
  return (
  <div className="lk-site">
    <Header />
    <main>
      <Hero />
      <Work />
      <Services />
      {/* Ready-made websites section hidden for now: import and render
          <Templates /> from ../Templates/Templates to bring it back. */}
      <Process />
      <About />
      <Contact />
    </main>
    <Footer />
  </div>
);
};

export default Home;
